/**
 * Per-page hydration entry for /about.
 */
import { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { About } from '@/pages/About.tsx';
import '@/styles/global.css';

const container = document.getElementById('root');
if (container) {
  hydrateRoot(
    container,
    <StrictMode>
      <About />
    </StrictMode>,
  );
}
